import { createReducer, on } from '@ngrx/store';
import { AddAvailableTariffs, AvailableTariffs, TariffStatusState } from '@products/models/tariff-status.model';
import { ResetProductsActions } from '@store/products/product.actions';
import { TariffStatusActions } from '@store/products/status/tariff/tariff-status.actions';
import { cloneDeep, forEach, keys } from 'lodash';

export { TariffStatusState as State };

export const initialState: TariffStatusState = {
  userAccountTariffLimit: null,
  userAccountTariffSpecificLimits: {},
  availableTariffs: {},
  isTariffLoading: false,
  isCreateContingentReservationLoading: false,
  isPromoCodeDiscountLoading: false
};

export const tariffStatusReducer = createReducer(
  initialState,
  on(TariffStatusActions.setUserAccountTariffsLimitStatus, (state, { userAccountTariffLimit }) => ({
    ...state,
    userAccountTariffLimit
  })),
  on(TariffStatusActions.setUserAccountTariffSpecificLimitsStatus, (state, { userAccountTariffSpecificLimits }) => ({
    ...state,
    userAccountTariffSpecificLimits
  })),
  on(TariffStatusActions.setAvailableTariffsStatus, (state, { availableTariffs }) => ({
    ...state,
    availableTariffs: { ...state.availableTariffs, ...availableTariffs }
  })),
  on(TariffStatusActions.setReleasedVoucherAvailableTariffsStatus, (state, { availableTariffs }) => {
    const addAvailableTariffs: AddAvailableTariffs = cloneDeep(availableTariffs);
    const clonedAvailableTariffs: AvailableTariffs = cloneDeep(state.availableTariffs);

    forEach(
      keys(addAvailableTariffs),
      (ticketPersonId) => (clonedAvailableTariffs[ticketPersonId] += addAvailableTariffs[ticketPersonId])
    );

    return {
      ...state,
      availableTariffs: clonedAvailableTariffs
    };
  }),
  on(TariffStatusActions.setIsTariffLoadingStatus, (state, { isTariffLoading }) => ({
    ...state,
    isTariffLoading
  })),
  on(
    TariffStatusActions.setIsCreateContingentReservationLoadingStatus,
    (state, { isCreateContingentReservationLoading }) => ({ ...state, isCreateContingentReservationLoading })
  ),
  on(TariffStatusActions.setIsPromoCodeDiscountLoadingStatus, (state, { isPromoCodeDiscountLoading }) => ({
    ...state,
    isPromoCodeDiscountLoading
  })),
  on(TariffStatusActions.resetReducer, ResetProductsActions.resetStatusReducer, () => initialState)
);
